/*
Controller used for the mobile initial filter screen
 */
bookingApp.controller('filterController',function($scope, $location, sessionFactory, propertyFactory, appFactory, $interval, $timeout, $http, $filter){
    $scope.session = sessionFactory;
    $scope.property = propertyFactory;
    $scope.baseApp = appFactory;
    $scope.baseApp.controls.type = "full";
    $scope.property.showRedirectConfirm = false;
    $scope.property.rooms = [];
    $scope.property.prices = [];

    if(propertyFactory.isMultiProp) {
        $scope.session.isLoading = true;
        $http.get('/front-booking/booking-context', {
                params: {
                    sid: $scope.session.sid,
                    format: 'json',
                    startDate: $filter('date')(sessionFactory.selectedFilters.checkin, 'yyyy-MM-dd'),
                    endDate: $filter('date')(sessionFactory.selectedFilters.checkout, 'yyyy-MM-dd')
                }
            })
            .success(function (data) {
                $scope.session.isLoading = false;
                $scope.session.propertyFilters.mapping = data.filterOptions.mapping;
                angular.forEach(session.propertyFilters.filters, function (filter) {
                    switch (filter.label) {
                        case 'Country':
                            filter.options = $filter('multiPropFiltersToArray')(data.filterOptions.countries);
                            break;
                        case 'City / Region':
                            filter.options = $filter('multiPropFiltersToArray')(data.filterOptions.regions);
                            break;
                        case 'Location':
                            filter.options = $filter('multiPropFiltersToArray')(data.filterOptions.locations);
                            break;
                        case 'Property Type':
                            filter.options = $filter('multiPropFiltersToArray')(data.filterOptions.types);
                            break;
                        case 'Rating':
                            //filter.options = data.filterOptions.countries;
                            break;
                        case 'Facilities':
                            filter.options = $filter('multiPropFiltersToArray')(data.filterOptions.facilities);
                            break;
                    }
                });
                $scope.safeApply();
            });
    }

    // setup footer
    $scope.footer.mainFunc = function(){
        if(!$scope.session.filtersForm.isValid){
            return false;
        } else {
            if($scope.mobileFiltersForm.$valid) {
                if($scope.session.template.isMultiTemplate) {
                    $location.path('properties')
                }
                else if($scope.mobileFiltersForm.checkin.$valid) {
                    $location.path('rooms');
                }
            }
        }
    };
    $scope.footer.display = {
        prev: false,
        main: true,
        next: false
    };
    $scope.footer.mainContent = '<strong><span class="footer-main-content">Next</span> <span class="glyphicon glyphicon-chevron-right"></span></strong>';

    // setup the availability calendar
    if($scope.property.showAvailabilityCal){
        var renderSquare = true;
        // set max checkin to two years from now
        session.maxCheckin = moment().add(2,'years').format('YYYY-MM-DD');
        // call the calendar initialiser.
        function refreshCal(){
            // setup the calendar
            $('#sk-availability-cal .calendar')
                .addClass('col-sm-12')
                .addClass('col-md-12')
                .removeClass('col-sm-6-')
                .removeClass('col-md-3');
            var newCheckin = moment($scope.session.selectedFilters.checkin);
            // run the query and reload the calendar...
            if(newCheckin.month() === moment().month() && newCheckin.year() === moment().year()){
                mobileAvailabilityCal.currentDate = moment().month(newCheckin.month()).year(newCheckin.year());
                mobileAvailabilityCal.toDate = newCheckin.endOf('month');
            } else {
                if(!newCheckin.isBefore(moment().add(2,'years')) || newCheckin.format('YYYY-MM') === moment().add(2,'years').format('YYYY-MM')){
                    mobileAvailabilityCal.currentDate = moment().date(1).add(2,'years');
                    mobileAvailabilityCal.toDate = moment().add(2,'years');
                } else {
                    mobileAvailabilityCal.currentDate = moment().date(1).month(newCheckin.month()).year(newCheckin.year());
                    mobileAvailabilityCal.toDate = newCheckin.endOf('month');
                }
            }
            $scope.mobileAvailabiltyCal = mobileAvailabilityCal;
            if((typeof mobileAvailabilityCal.cal1 !== 'undefined') && mobileAvailabilityCal.cal1 && (typeof mobileAvailabilityCal.cal1.setMonth !== 'undefined')){
                if(!newCheckin.isBefore(moment().add(2,'years'))){
                    mobileAvailabilityCal.cal1.setMonth(moment().month());
                    mobileAvailabilityCal.cal1.setYear(moment().add(2,'years').year());
                } else {
                    mobileAvailabilityCal.cal1.setMonth(moment($scope.session.selectedFilters.checkin).month());
                    mobileAvailabilityCal.cal1.setYear(moment($scope.session.selectedFilters.checkin).year());
                }
                mobileAvailabilityCal.getUpdatedEvents();
            }
            if(renderSquare) {
                $('#mobile-availability-calendar').find('.selected').removeClass('selected');
                $('#mobile-availability-calendar').find('.calendar-day-' + moment($scope.session.selectedFilters.checkin).format('YYYY-MM-DD')).click();
            } else {
                renderSquare = true;
            }
        }

        var mobileAvailabilityCal = new skAvailabilityCal('mobile-availability-calendar',{
            opid: $scope.property.accountId,
            propid: $scope.property.id,
            showLegendHeading: true,
            legendHeadingText: 'Availability',
            showCalendarHeading: false,
            roomIds: $scope.property.filteredBookables,
            showMonthPicker: false,
            showYearPicker: false,
            resourcesRoot: '/albatross/static/js/vendor/skAvailabilityCalEmb/',
            showScrollers: true,
            isMultiProp: $scope.property.isMultiProp,
            templateId: $scope.property.template.id,
            excludeLoaders: ['bootstrap','moment'],
            domainURL: (typeof availabilityCalDomain === 'undefined') ? null : availabilityCalDomain,
            dateClickCallback: function(date){
                // update the selected filters checkin date
                if(moment(date.date).isAfter(moment().add(2,'years'))){
                    $scope.session.selectedFilters.checkin = moment().add(2,'years').toDate();
                } else {
                    $scope.session.selectedFilters.checkin = date.date.toDate();
                }
                renderSquare = false;
                $scope.safeApply();
            },
            selectedDate: $scope.session.selectedFilters.checkin,
            trackSelectedDate: true,
            calendarsShowing: 1
        }, refreshCal);


        // watch checkin date and set availability calendar accordingly
        $scope.$watch('session.selectedFilters.checkin', function(){
            refreshCal();
        });
    }


    // setup the checkin date base on whether property allows same day bookings
    //if(!$scope.property.allowSameDayBookings){
    //    if(moment($scope.session.selectedFilters.checkin).isBefore(moment())) {
    //        // set add a day to the checkin date
    //        $scope.session.selectedFilters.checkin = moment($scope.session.selectedFilters.checkin).add(1, 'd').toDate();
    //    }
    //}
    // update the checkout date based on the nights changing or the checkin changing
    $scope.$watchGroup(['session.selectedFilters.checkin','session.selectedFilters.nights'],function(){
        var mDate = moment(session.selectedFilters.checkin).add((session.selectedFilters.nights <= 0) ? 1 : session.selectedFilters.nights,'days');
        $scope.session.selectedFilters.checkout = mDate.toDate();
        // reset the property rooms, start and end count values - removes chance of split date booking
        $scope.property.rooms = [];
        $scope.property.roomAvailabilities = [];
        $scope.session.firstRoom = 0;
        $scope.session.loadMore.rooms = true;
        $scope.cart.rooms = [];
        $scope.cart.extras = [];

    });

    $scope.$watch('session.selectedFilters',function(newValue, oldValue){
        var dayInMilliSeconds = -864000000;
        var dateDiff = ($scope.property.allowSameDayBookings) ? dayInMilliSeconds : dayInMilliSeconds * 2;
        // verify date is either today or in future
        if(!$scope.mobileFiltersForm.checkin.$error.required) {
            if ($scope.property.allowSameDayBookings) {
                if (moment($scope.session.selectedFilters.checkin).diff(moment($scope.session.minCheckin)) < -86400000) {
                    $scope.mobileFiltersForm.checkin.$setValidity('required', false);
                    $scope.session.filtersForm.isValid = false;
                } else {
                    $scope.mobileFiltersForm.checkin.$setValidity('required', true);
                    $scope.session.filtersForm.isValid = true;
                }
            } else {
                if (moment($scope.session.selectedFilters.checkin).diff(moment($scope.session.minCheckin)) < 0) {
                    $scope.mobileFiltersForm.checkin.$setValidity('required', false);
                    $scope.session.filtersForm.isValid = false;
                } else {
                    $scope.mobileFiltersForm.checkin.$setValidity('required', true);
                    $scope.session.filtersForm.isValid = true;
                }
            }
        }
    }, true);
});
